import { inject, NewInstance, BindingEngine } from 'aurelia-framework';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController, DialogService } from 'aurelia-dialog';
import { UnitOfMeasurementService } from 'pages/system-fields/unit-of-measurements/service';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), ProcessService, EventAggregator, BindingEngine, DialogService, UnitOfMeasurementService)
export class ProcessEditor {
    constructor(controller, validationController, processService, ea, bindingEngine, dialogService, unitOfMeasurementService) {
        this.controller = controller;
        this.processService = processService;
        this.unitOfMeasurementService = unitOfMeasurementService;
        this.dialogService = dialogService;
        this.ea = ea;
        this.process = {};

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    addUnitOfMeasurement () {
        this.dialogService.open({ viewModel: this.unitOfMeasurementService.editor });
    }

    async activate(model) {
        if (model?.id != null) {
            this.process = await this.processService.getById(model.id);
        }
    }

 

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.process.id) {
                    await this.processService.update(this.process);
                    toastr.success('Process was updated!');
                } else {
                    await this.processService.create(this.process);
                    toastr.success('New process was created!');
                }
                this.ea.publish('processes:updated', this.process);
                this.controller.ok(this.process);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}